import React, { Component } from "react";
import {
  Column,
  DataGrid,
  Paging,
  Pager,
  Button as GridButton,
} from "devextreme-react/data-grid";
import { Editing } from "devextreme-react/scheduler";
import PaginaToolbar from "../components/PaginaToolbar";
import { criarBairroDs } from "../DataSources";
import uiInfo from "../ui-info";
import UserInfo from "../UserInfo";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import { Button } from "devextreme-react";

export default class BairrosBox extends Component {
  constructor(props) {
    super(props);
    this.initNewRow = this.initNewRow.bind(this);
    this.state = {
      filtroCorrente: [],
      filtro: {},
    };
    this._gridInstance = React.createRef();
    this.filtrar = this.filtrar.bind(this);
    this.limparFiltro = this.limparFiltro.bind(this);
    this.onSelecionado = props.onSelecionado;
    this.usadoComoPesquisa = props.onSelecionado !== undefined;
  }

  filtrar(e) {
    let filtro = this.state.filtro;

    let filtroCorrente = [];
    if (filtro !== undefined) {
      if (filtro.descricao !== null && filtro.descricao !== undefined) {
        filtroCorrente.push(["descricao", "contains", filtro.descricao]);
      }
    }

    this._gridInstance.instance.filter(
      filtroCorrente.length > 0 ? filtroCorrente : null
    );
  }

  limparFiltro(e) {
    this.setState({ filtro: {} });
    this.filtrar();
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form onSubmit={this.filtrar}>
            <Form
              id="frmPesquisa"
              formData={this.state.filtro}
              colCount={1}
              labelLocation={"top"}
            >
              <SimpleItem dataField="descricao" colSpan={1}>
                <Label text="Nome" />
              </SimpleItem>
            </Form>
            <br />
            <div
              style={{
                marginTop: "10px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Filtrar"
                  type="success"
                  onClick={this.filtrar}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Limpar Filtro" onClick={this.limparFiltro} />
              </div>
            </div>
          </form>
          <br />
          <br />
          <PaginaToolbar titulo="BAIRROS">
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={criarBairroDs()}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              wordWrapEnabled={true}
              columnAutoWidth={true}
              focusedRowEnabled={true}
              onInitNewRow={this.initNewRow}
            >
              <Editing
                mode={"row"}
                allowAdding={false}
                allowUpdating={true}
                allowDeleting={true}
              />
              <Column
                type="buttons"
                fixed={true}
                fixedPosition={"left"}
                allowEditing={false}
                width={140}
              >
                <GridButton name="edit" visible={!this.usadoComoPesquisa} />
                <GridButton name="delete" visible={!this.usadoComoPesquisa} />
                <GridButton
                  hint="Selecionar"
                  icon="repeat"
                  visible={this.usadoComoPesquisa}
                  onClick={this.onSelecionado}
                />
              </Column>
              <Column
                dataField={"sequencial"}
                allowEditing={false}
                alignment={"center"}
                width={80}
                caption={"#"}
              />
              <Column
                dataField={"id"}
                allowEditing={false}
                visible={false}
                alignment={"center"}
                width={80}
                caption={"ID Interno"}
              />
              <Column dataField={"descricao"} />
              <Column dataField={"codigoRefProducao"} caption={"Cód. Ref. Produção"} visible={false} />
              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
              <Pager
                showPageSizeSelector={uiInfo.tamanhoPaginaOpcoes}
                allowedPageSizes={uiInfo.tamanhoPaginaPadrao}
              />
            </DataGrid>
          </PaginaToolbar>
        </div>
      </React.Fragment>
    );
  }

  initNewRow(e) {
    e.data.prefeituraId = UserInfo.getPrefeitura();
  }
}
